import { render } from "./ThePatientPurchaseAuthorizationList.vue?vue&type=template&id=d3eca95e&scoped=true&ts=true"
import script from "./ThePatientPurchaseAuthorizationList.vue?vue&type=script&lang=ts"
export * from "./ThePatientPurchaseAuthorizationList.vue?vue&type=script&lang=ts"

import "./ThePatientPurchaseAuthorizationList.vue?vue&type=style&index=0&id=d3eca95e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3eca95e"]])

export default __exports__